import { Typography } from 'antd'

const InvalidConfiguration: React.FC = () => (
  <Typography.Paragraph>
    <Typography.Text strong type="danger">
      Invalid configuration
    </Typography.Text>
    . If you are enabling the <Typography.Text code>expand</Typography.Text>{' '}
    options, you must configure at least one of the{' '}
    <Typography.Text code>RenderExpandableSectionOptions</Typography.Text>{' '}
    properties.
  </Typography.Paragraph>
)

export default InvalidConfiguration
